<app-navbar></app-navbar>

<!-- Skeleton Loader -->
<div class="container py-5" *ngIf="fetchinData">
    <div class="row g-4">
        <div class="col-lg-4 col-md-12">
            <div class="glassmorphism card rounded p-4 border-0">
                <p class="placeholder-glow">
                    <span class="placeholder col-12" style="height: 250px; border-radius: 8px;"></span>
                </p>
                <p class="placeholder-glow mt-3">
                    <span class="placeholder col-8" style="height: 20px;"></span>
                    <span class="placeholder col-6 mt-2" style="height: 15px;"></span>
                </p>
            </div>
        </div>
        <div class="col-lg-8 col-md-12">
            <div class="glassmorphism card rounded p-4 h-100 border-0">
                <p class="placeholder-glow">
                    <span class="placeholder col-6" style="height: 30px; margin-bottom: 20px;"></span>
                    <span class="placeholder col-12 mt-2"></span>
                    <span class="placeholder col-12 mt-2"></span>
                    <span class="placeholder col-12 mt-2"></span>
                    <span class="placeholder col-10 mt-2"></span>
                    <span class="placeholder col-8 mt-2"></span>
                </p>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container" *ngIf="
            currentContentData.LayOut == 1 && currentContentData.FileType == 1
        ">
        <!-- This component is for multiple list view image and description -->
        <app-layout-image-list [inputData]="currentContentData"></app-layout-image-list>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container" *ngIf="
            currentContentData.LayOut == 2 && currentContentData.FileType == 1
        ">
        <!-- This component for one big image and a description -->
        <app-layout-image-single [inputData]="currentContentData"></app-layout-image-single>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container" *ngIf="
            currentContentData.LayOut == 3 && currentContentData.FileType == 1
        ">
        <app-layout-image-multiple [inputData]="currentContentData"></app-layout-image-multiple>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container" *ngIf="
            currentContentData.LayOut == 1 && currentContentData.FileType == 3
        ">
        <!-- For View Pdf and  -->
        <app-layout-document-list [inputData]="currentContentData"></app-layout-document-list>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div class="container" *ngIf="
            currentContentData.LayOut == 2 && currentContentData.FileType == 3
        ">
        <app-layout-document-single [inputData]="currentContentData"></app-layout-document-single>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData != null">
    <div style="margin-top: 50px" *ngIf="
            currentContentData.LayOut == 2 && currentContentData.FileType == 0
        ">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content" style="margin-top: 100px">
                        <h2>No Data Found</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!fetchinData && currentContentData == null">
    <div class="container" style="padding-top: 30px; padding-bottom: 30px;color: var(--text-primary) !important;">
        <div class="row">
            <div class="col-md-12">
                <div style="min-height: 800px">
                    <h3 style="color: var(--text-primary);" *ngIf="currentMenuItem">{{ currentMenuItem.DisplayNameBangla
                        }}</h3>
                    <div class="container card glassmorphism" style="padding: 20px; border: 0;">
                        <div class="page-title-content"
                            style="margin-top: 100px; margin-bottom: 100px; text-align: center;">
                            <h2 style="color: var(--text-primary);">No Data Found</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="fetchinData">
    <div aria-hidden="true" class="col-lg-12 col-md-12">
        <h5 class="placeholder-glow">
            <span class="placeholder col-12" style="height: 800px"></span>
        </h5>
    </div>
</ng-container>
<!-- 
<app-footer></app-footer> -->